const Attendance = {
  LATE: 'Late',
  ABSENT: 'Absent',
  NO_SHOW: 'No-Show',
  PRESENT: 'Present',
  LEFT_EARLY: 'Left-Early',
};
module.exports = Attendance;
